import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var EmbeddingSourceType = /*#__PURE__*/function (EmbeddingSourceType) {
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_INVALID"] = 0] = "EMBEDDING_SOURCE_TYPE_INVALID";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_USER_INPUT"] = 1] = "EMBEDDING_SOURCE_TYPE_USER_INPUT";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_WEBSITE"] = 2] = "EMBEDDING_SOURCE_TYPE_WEBSITE";
  EmbeddingSourceType[EmbeddingSourceType["EMBEDDING_SOURCE_TYPE_BUSINESS_PROFILE"] = 3] = "EMBEDDING_SOURCE_TYPE_BUSINESS_PROFILE";
  return EmbeddingSourceType;
}(EmbeddingSourceType || {});
var EmbeddingVendorModel = /*#__PURE__*/function (EmbeddingVendorModel) {
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_INVALID"] = 0] = "EMBEDDING_MODEL_INVALID";
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_OPENAI_ADA_V2"] = 1] = "EMBEDDING_MODEL_OPENAI_ADA_V2";
  EmbeddingVendorModel[EmbeddingVendorModel["EMBEDDING_MODEL_GOOGLE_GECKO_V2"] = 2] = "EMBEDDING_MODEL_GOOGLE_GECKO_V2";
  return EmbeddingVendorModel;
}(EmbeddingVendorModel || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var KnowledgeSourceConfigType = /*#__PURE__*/function (KnowledgeSourceConfigType) {
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_INVALID"] = 0] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_INVALID";
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_BUSINESS_PROFILE"] = 1] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_BUSINESS_PROFILE";
  KnowledgeSourceConfigType[KnowledgeSourceConfigType["KNOWLEDGE_SOURCE_CONFIG_TYPE_CUSTOM_DATA"] = 2] = "KNOWLEDGE_SOURCE_CONFIG_TYPE_CUSTOM_DATA";
  return KnowledgeSourceConfigType;
}(KnowledgeSourceConfigType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var RefreshAccountGroupWebsiteEmbeddingsProgress = /*#__PURE__*/function (RefreshAccountGroupWebsiteEmbeddingsProgress) {
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_INVALID"] = 0] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_INVALID";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_SCRAPE_STARTED"] = 1] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_SCRAPE_STARTED";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_ANALYSIS_STARTED"] = 2] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_ANALYSIS_STARTED";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_COMPLETE"] = 3] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_COMPLETE";
  RefreshAccountGroupWebsiteEmbeddingsProgress[RefreshAccountGroupWebsiteEmbeddingsProgress["REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_FAILED"] = 4] = "REFRESH_WEBSITE_EMBEDDINGS_PROGRESS_FAILED";
  return RefreshAccountGroupWebsiteEmbeddingsProgress;
}(RefreshAccountGroupWebsiteEmbeddingsProgress || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Embedding {
  static fromProto(proto) {
    let m = new Embedding();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = EmbeddingMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.originalContent !== 'undefined') {
      toReturn['originalContent'] = this.originalContent;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class EmbeddingCitation {
  static fromProto(proto) {
    let m = new EmbeddingCitation();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.link !== 'undefined') {
      toReturn['link'] = this.link;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class EmbeddingMetadata {
  static fromProto(proto) {
    let m = new EmbeddingMetadata();
    m = Object.assign(m, proto);
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.updatedAt) {
      m.updatedAt = new Date(proto.updatedAt);
    }
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = enumStringToValue$4(EmbeddingSourceType, proto.sourceType);
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue$4(EmbeddingVendorModel, proto.vendorModel);
    }
    if (proto.citation) {
      m.citation = EmbeddingCitation.fromProto(proto.citation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.createdBy !== 'undefined') {
      toReturn['createdBy'] = this.createdBy;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.updatedAt !== 'undefined' && this.updatedAt !== null) {
      toReturn['updatedAt'] = 'toApiJson' in this.updatedAt ? this.updatedAt.toApiJson() : this.updatedAt;
    }
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.sourceFeature !== 'undefined') {
      toReturn['sourceFeature'] = this.sourceFeature;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.citation !== 'undefined' && this.citation !== null) {
      toReturn['citation'] = 'toApiJson' in this.citation ? this.citation.toApiJson() : this.citation;
    }
    if (typeof this.disabled !== 'undefined') {
      toReturn['disabled'] = this.disabled;
    }
    return toReturn;
  }
}
class EmbeddingRelationship {
  static fromProto(proto) {
    let m = new EmbeddingRelationship();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = EmbeddingRelationshipAccountGroup.fromProto(proto.accountGroup);
    }
    if (proto.partner) {
      m.partner = EmbeddingRelationshipPartner.fromProto(proto.partner);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    if (typeof this.partner !== 'undefined' && this.partner !== null) {
      toReturn['partner'] = 'toApiJson' in this.partner ? this.partner.toApiJson() : this.partner;
    }
    return toReturn;
  }
}
class EmbeddingRelationshipAccountGroup {
  static fromProto(proto) {
    let m = new EmbeddingRelationshipAccountGroup();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class EmbeddingRelationshipPartner {
  static fromProto(proto) {
    let m = new EmbeddingRelationshipPartner();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class NamespaceAccountGroupNamespace {
  static fromProto(proto) {
    let m = new NamespaceAccountGroupNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class App {
  static fromProto(proto) {
    let m = new App();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.knowledgeBaseKeys) {
      m.knowledgeBaseKeys = proto.knowledgeBaseKeys.map(KnowledgeBaseKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.configurationUrl !== 'undefined') {
      toReturn['configurationUrl'] = this.configurationUrl;
    }
    if (typeof this.knowledgeBaseKeys !== 'undefined' && this.knowledgeBaseKeys !== null) {
      toReturn['knowledgeBaseKeys'] = 'toApiJson' in this.knowledgeBaseKeys ? this.knowledgeBaseKeys.toApiJson() : this.knowledgeBaseKeys;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigBusinessProfileConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigBusinessProfileConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfigCustomDataConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfigCustomDataConfig();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.fileUrl !== 'undefined') {
      toReturn['fileUrl'] = this.fileUrl;
    }
    return toReturn;
  }
}
class KnowledgeBase {
  static fromProto(proto) {
    let m = new KnowledgeBase();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.knowledgeSourceKeys) {
      m.knowledgeSourceKeys = proto.knowledgeSourceKeys.map(KnowledgeSourceKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.knowledgeSourceKeys !== 'undefined' && this.knowledgeSourceKeys !== null) {
      toReturn['knowledgeSourceKeys'] = 'toApiJson' in this.knowledgeSourceKeys ? this.knowledgeSourceKeys.toApiJson() : this.knowledgeSourceKeys;
    }
    return toReturn;
  }
}
class KnowledgeBaseKey {
  static fromProto(proto) {
    let m = new KnowledgeBaseKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBaseId !== 'undefined') {
      toReturn['knowledgeBaseId'] = this.knowledgeBaseId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class KnowledgeSource {
  static fromProto(proto) {
    let m = new KnowledgeSource();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.config) {
      m.config = KnowledgeSourceConfig.fromProto(proto.config);
    }
    if (proto.knowledgeBaseKeys) {
      m.knowledgeBaseKeys = proto.knowledgeBaseKeys.map(KnowledgeBaseKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    if (typeof this.knowledgeBaseKeys !== 'undefined' && this.knowledgeBaseKeys !== null) {
      toReturn['knowledgeBaseKeys'] = 'toApiJson' in this.knowledgeBaseKeys ? this.knowledgeBaseKeys.toApiJson() : this.knowledgeBaseKeys;
    }
    return toReturn;
  }
}
class KnowledgeSourceConfig {
  static fromProto(proto) {
    let m = new KnowledgeSourceConfig();
    m = Object.assign(m, proto);
    if (proto.businessProfileConfig) {
      m.businessProfileConfig = KnowledgeSourceConfigBusinessProfileConfig.fromProto(proto.businessProfileConfig);
    }
    if (proto.customDataConfig) {
      m.customDataConfig = KnowledgeSourceConfigCustomDataConfig.fromProto(proto.customDataConfig);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessProfileConfig !== 'undefined' && this.businessProfileConfig !== null) {
      toReturn['businessProfileConfig'] = 'toApiJson' in this.businessProfileConfig ? this.businessProfileConfig.toApiJson() : this.businessProfileConfig;
    }
    if (typeof this.customDataConfig !== 'undefined' && this.customDataConfig !== null) {
      toReturn['customDataConfig'] = 'toApiJson' in this.customDataConfig ? this.customDataConfig.toApiJson() : this.customDataConfig;
    }
    return toReturn;
  }
}
class KnowledgeSourceKey {
  static fromProto(proto) {
    let m = new KnowledgeSourceKey();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceId !== 'undefined') {
      toReturn['knowledgeSourceId'] = this.knowledgeSourceId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class Namespace {
  static fromProto(proto) {
    let m = new Namespace();
    m = Object.assign(m, proto);
    if (proto.accountGroupNamespace) {
      m.accountGroupNamespace = NamespaceAccountGroupNamespace.fromProto(proto.accountGroupNamespace);
    }
    if (proto.partnerNamespace) {
      m.partnerNamespace = NamespacePartnerNamespace.fromProto(proto.partnerNamespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNamespace !== 'undefined' && this.accountGroupNamespace !== null) {
      toReturn['accountGroupNamespace'] = 'toApiJson' in this.accountGroupNamespace ? this.accountGroupNamespace.toApiJson() : this.accountGroupNamespace;
    }
    if (typeof this.partnerNamespace !== 'undefined' && this.partnerNamespace !== null) {
      toReturn['partnerNamespace'] = 'toApiJson' in this.partnerNamespace ? this.partnerNamespace.toApiJson() : this.partnerNamespace;
    }
    return toReturn;
  }
}
class NamespacePartnerNamespace {
  static fromProto(proto) {
    let m = new NamespacePartnerNamespace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CreateEmbeddingRequest {
  static fromProto(proto) {
    let m = new CreateEmbeddingRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = EmbeddingMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.content !== 'undefined') {
      toReturn['content'] = this.content;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class CreateEmbeddingResponse {
  static fromProto(proto) {
    let m = new CreateEmbeddingResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class CreateKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new CreateKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    return toReturn;
  }
}
class CreateKnowledgeBaseResponse {
  static fromProto(proto) {
    let m = new CreateKnowledgeBaseResponse();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class CreateKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new CreateKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    return toReturn;
  }
}
class CreateKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new CreateKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteAppRequest {
  static fromProto(proto) {
    let m = new DeleteAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteEmbeddingRequest {
  static fromProto(proto) {
    let m = new DeleteEmbeddingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddingId !== 'undefined') {
      toReturn['embeddingId'] = this.embeddingId;
    }
    return toReturn;
  }
}
class DeleteKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new DeleteKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class DeleteKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new DeleteKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesRequestFilters {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsRequestFilters {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = proto.sourceType.map(v => enumStringToValue(EmbeddingSourceType, v));
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue(EmbeddingVendorModel, proto.vendorModel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.associatedAppId !== 'undefined') {
      toReturn['associatedAppId'] = this.associatedAppId;
    }
    return toReturn;
  }
}
class ListEmbeddingsRequestFilters {
  static fromProto(proto) {
    let m = new ListEmbeddingsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.relationship) {
      m.relationship = EmbeddingRelationship.fromProto(proto.relationship);
    }
    if (proto.sourceType) {
      m.sourceType = proto.sourceType.map(v => enumStringToValue(EmbeddingSourceType, v));
    }
    if (proto.vendorModel) {
      m.vendorModel = enumStringToValue(EmbeddingVendorModel, proto.vendorModel);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.relationship !== 'undefined' && this.relationship !== null) {
      toReturn['relationship'] = 'toApiJson' in this.relationship ? this.relationship.toApiJson() : this.relationship;
    }
    if (typeof this.sourceType !== 'undefined') {
      toReturn['sourceType'] = this.sourceType;
    }
    if (typeof this.vendorModel !== 'undefined') {
      toReturn['vendorModel'] = this.vendorModel;
    }
    if (typeof this.associatedAppId !== 'undefined') {
      toReturn['associatedAppId'] = this.associatedAppId;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppRequestFilters {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppRequestFilters();
    m = Object.assign(m, proto);
    if (proto.configTypes) {
      m.configTypes = proto.configTypes.map(v => enumStringToValue(KnowledgeSourceConfigType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.configTypes !== 'undefined') {
      toReturn['configTypes'] = this.configTypes;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesRequestFilters {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.configTypes) {
      m.configTypes = proto.configTypes.map(v => enumStringToValue(KnowledgeSourceConfigType, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.configTypes !== 'undefined') {
      toReturn['configTypes'] = this.configTypes;
    }
    return toReturn;
  }
}
class ListAppsRequestFilters {
  static fromProto(proto) {
    let m = new ListAppsRequestFilters();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsRequest {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = FindSimilarEmbeddingsRequestFilters.fromProto(proto.filters);
    }
    if (proto.limit) {
      m.limit = parseInt(proto.limit, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.query !== 'undefined') {
      toReturn['query'] = this.query;
    }
    if (typeof this.limit !== 'undefined') {
      toReturn['limit'] = this.limit;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsResponse {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsResponse();
    m = Object.assign(m, proto);
    if (proto.embeddings) {
      m.embeddings = proto.embeddings.map(FindSimilarEmbeddingsResponseMatch.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddings !== 'undefined' && this.embeddings !== null) {
      toReturn['embeddings'] = 'toApiJson' in this.embeddings ? this.embeddings.toApiJson() : this.embeddings;
    }
    return toReturn;
  }
}
class GetAppRequest {
  static fromProto(proto) {
    let m = new GetAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class GetAppResponse {
  static fromProto(proto) {
    let m = new GetAppResponse();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class GetEmbeddingRequest {
  static fromProto(proto) {
    let m = new GetEmbeddingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    return toReturn;
  }
}
class GetEmbeddingResponse {
  static fromProto(proto) {
    let m = new GetEmbeddingResponse();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    return toReturn;
  }
}
class GetKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new GetKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeSourceKeys !== 'undefined') {
      toReturn['includeKnowledgeSourceKeys'] = this.includeKnowledgeSourceKeys;
    }
    return toReturn;
  }
}
class GetKnowledgeBaseResponse {
  static fromProto(proto) {
    let m = new GetKnowledgeBaseResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    return toReturn;
  }
}
class GetKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new GetKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class GetKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new GetKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    return toReturn;
  }
}
class GetRefreshAccountGroupWebsiteEmbeddingsProgressRequest {
  static fromProto(proto) {
    let m = new GetRefreshAccountGroupWebsiteEmbeddingsProgressRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    return toReturn;
  }
}
class GetRefreshAccountGroupWebsiteEmbeddingsProgressResponse {
  static fromProto(proto) {
    let m = new GetRefreshAccountGroupWebsiteEmbeddingsProgressResponse();
    m = Object.assign(m, proto);
    if (proto.state) {
      m.state = enumStringToValue(RefreshAccountGroupWebsiteEmbeddingsProgress, proto.state);
    }
    if (proto.createdAt) {
      m.createdAt = new Date(proto.createdAt);
    }
    if (proto.finishedAt) {
      m.finishedAt = new Date(proto.finishedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.progress !== 'undefined') {
      toReturn['progress'] = this.progress;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.createdAt !== 'undefined' && this.createdAt !== null) {
      toReturn['createdAt'] = 'toApiJson' in this.createdAt ? this.createdAt.toApiJson() : this.createdAt;
    }
    if (typeof this.finishedAt !== 'undefined' && this.finishedAt !== null) {
      toReturn['finishedAt'] = 'toApiJson' in this.finishedAt ? this.finishedAt.toApiJson() : this.finishedAt;
    }
    return toReturn;
  }
}
class ListAllAppsForKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new ListAllAppsForKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSourceId !== 'undefined') {
      toReturn['knowledgeSourceId'] = this.knowledgeSourceId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    return toReturn;
  }
}
class ListAllAppsForKnowledgeSourceResponse {
  static fromProto(proto) {
    let m = new ListAllAppsForKnowledgeSourceResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppRequest {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppRequest();
    m = Object.assign(m, proto);
    if (proto.namespace) {
      m.namespace = Namespace.fromProto(proto.namespace);
    }
    if (proto.filters) {
      m.filters = ListAllKnowledgeSourcesForAppRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.namespace !== 'undefined' && this.namespace !== null) {
      toReturn['namespace'] = 'toApiJson' in this.namespace ? this.namespace.toApiJson() : this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAllKnowledgeSourcesForAppResponse {
  static fromProto(proto) {
    let m = new ListAllKnowledgeSourcesForAppResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSources) {
      m.knowledgeSources = proto.knowledgeSources.map(KnowledgeSource.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSources !== 'undefined' && this.knowledgeSources !== null) {
      toReturn['knowledgeSources'] = 'toApiJson' in this.knowledgeSources ? this.knowledgeSources.toApiJson() : this.knowledgeSources;
    }
    return toReturn;
  }
}
class ListAppsRequest {
  static fromProto(proto) {
    let m = new ListAppsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListAppsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class ListAppsResponse {
  static fromProto(proto) {
    let m = new ListAppsResponse();
    m = Object.assign(m, proto);
    if (proto.apps) {
      m.apps = proto.apps.map(App.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.apps !== 'undefined' && this.apps !== null) {
      toReturn['apps'] = 'toApiJson' in this.apps ? this.apps.toApiJson() : this.apps;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListEmbeddingsRequest {
  static fromProto(proto) {
    let m = new ListEmbeddingsRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListEmbeddingsRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListEmbeddingsResponse {
  static fromProto(proto) {
    let m = new ListEmbeddingsResponse();
    m = Object.assign(m, proto);
    if (proto.embeddings) {
      m.embeddings = proto.embeddings.map(Embedding.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embeddings !== 'undefined' && this.embeddings !== null) {
      toReturn['embeddings'] = 'toApiJson' in this.embeddings ? this.embeddings.toApiJson() : this.embeddings;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesRequest {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListKnowledgeBasesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeSourceKeys !== 'undefined') {
      toReturn['includeKnowledgeSourceKeys'] = this.includeKnowledgeSourceKeys;
    }
    return toReturn;
  }
}
class ListKnowledgeBasesResponse {
  static fromProto(proto) {
    let m = new ListKnowledgeBasesResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeBases) {
      m.knowledgeBases = proto.knowledgeBases.map(KnowledgeBase.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBases !== 'undefined' && this.knowledgeBases !== null) {
      toReturn['knowledgeBases'] = 'toApiJson' in this.knowledgeBases ? this.knowledgeBases.toApiJson() : this.knowledgeBases;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesRequest {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListKnowledgeSourcesRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.includeKnowledgeBaseKeys !== 'undefined') {
      toReturn['includeKnowledgeBaseKeys'] = this.includeKnowledgeBaseKeys;
    }
    return toReturn;
  }
}
class ListKnowledgeSourcesResponse {
  static fromProto(proto) {
    let m = new ListKnowledgeSourcesResponse();
    m = Object.assign(m, proto);
    if (proto.knowledgeSources) {
      m.knowledgeSources = proto.knowledgeSources.map(KnowledgeSource.fromProto);
    }
    if (proto.metadata) {
      m.metadata = PagedResponseMetadata.fromProto(proto.metadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSources !== 'undefined' && this.knowledgeSources !== null) {
      toReturn['knowledgeSources'] = 'toApiJson' in this.knowledgeSources ? this.knowledgeSources.toApiJson() : this.knowledgeSources;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    return toReturn;
  }
}
class FindSimilarEmbeddingsResponseMatch {
  static fromProto(proto) {
    let m = new FindSimilarEmbeddingsResponseMatch();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    if (typeof this.similarity !== 'undefined') {
      toReturn['similarity'] = this.similarity;
    }
    return toReturn;
  }
}
class RefreshAccountGroupWebsiteEmbeddingsRequest {
  static fromProto(proto) {
    let m = new RefreshAccountGroupWebsiteEmbeddingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class RefreshAccountGroupWebsiteEmbeddingsResponse {
  static fromProto(proto) {
    let m = new RefreshAccountGroupWebsiteEmbeddingsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    return toReturn;
  }
}
class RefreshBusinessProfileEmbeddingsRequest {
  static fromProto(proto) {
    let m = new RefreshBusinessProfileEmbeddingsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class UpdateEmbeddingRequest {
  static fromProto(proto) {
    let m = new UpdateEmbeddingRequest();
    m = Object.assign(m, proto);
    if (proto.embedding) {
      m.embedding = Embedding.fromProto(proto.embedding);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.embedding !== 'undefined' && this.embedding !== null) {
      toReturn['embedding'] = 'toApiJson' in this.embedding ? this.embedding.toApiJson() : this.embedding;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateKnowledgeBaseRequest {
  static fromProto(proto) {
    let m = new UpdateKnowledgeBaseRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeBase) {
      m.knowledgeBase = KnowledgeBase.fromProto(proto.knowledgeBase);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeBase !== 'undefined' && this.knowledgeBase !== null) {
      toReturn['knowledgeBase'] = 'toApiJson' in this.knowledgeBase ? this.knowledgeBase.toApiJson() : this.knowledgeBase;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateKnowledgeSourceRequest {
  static fromProto(proto) {
    let m = new UpdateKnowledgeSourceRequest();
    m = Object.assign(m, proto);
    if (proto.knowledgeSource) {
      m.knowledgeSource = KnowledgeSource.fromProto(proto.knowledgeSource);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.knowledgeSource !== 'undefined' && this.knowledgeSource !== null) {
      toReturn['knowledgeSource'] = 'toApiJson' in this.knowledgeSource ? this.knowledgeSource.toApiJson() : this.knowledgeSource;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAppRequest {
  static fromProto(proto) {
    let m = new UpsertAppRequest();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    return toReturn;
  }
}
class UpsertKnowledgeForAppRequest {
  static fromProto(proto) {
    let m = new UpsertKnowledgeForAppRequest();
    m = Object.assign(m, proto);
    if (proto.app) {
      m.app = App.fromProto(proto.app);
    }
    if (proto.configs) {
      m.configs = proto.configs.map(KnowledgeSourceConfig.fromProto);
    }
    if (proto.knowledgeSourceKeys) {
      m.knowledgeSourceKeys = proto.knowledgeSourceKeys.map(KnowledgeSourceKey.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.app !== 'undefined' && this.app !== null) {
      toReturn['app'] = 'toApiJson' in this.app ? this.app.toApiJson() : this.app;
    }
    if (typeof this.configs !== 'undefined' && this.configs !== null) {
      toReturn['configs'] = 'toApiJson' in this.configs ? this.configs.toApiJson() : this.configs;
    }
    if (typeof this.knowledgeSourceKeys !== 'undefined' && this.knowledgeSourceKeys !== null) {
      toReturn['knowledgeSourceKeys'] = 'toApiJson' in this.knowledgeSourceKeys ? this.knowledgeSourceKeys.toApiJson() : this.knowledgeSourceKeys;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'embeddings-api.vendasta-local.com',
  'test': '',
  'demo': 'embeddings-demo.apigateway.co',
  'prod': 'embeddings-prod.apigateway.co',
  'production': 'embeddings-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let EmbeddingApiService = /*#__PURE__*/(() => {
  class EmbeddingApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createEmbedding(r) {
      const request = r.toApiJson ? r : new CreateEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/CreateEmbedding", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateEmbeddingResponse.fromProto(resp)));
    }
    getEmbedding(r) {
      const request = r.toApiJson ? r : new GetEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/GetEmbedding", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEmbeddingResponse.fromProto(resp)));
    }
    updateEmbedding(r) {
      const request = r.toApiJson ? r : new UpdateEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/UpdateEmbedding", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteEmbedding(r) {
      const request = r.toApiJson ? r : new DeleteEmbeddingRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/DeleteEmbedding", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listEmbeddings(r) {
      const request = r.toApiJson ? r : new ListEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/ListEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListEmbeddingsResponse.fromProto(resp)));
    }
    findSimilarEmbeddings(r) {
      const request = r.toApiJson ? r : new FindSimilarEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.EmbeddingService/FindSimilarEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => FindSimilarEmbeddingsResponse.fromProto(resp)));
    }
  }
  EmbeddingApiService.ɵfac = function EmbeddingApiService_Factory(t) {
    return new (t || EmbeddingApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  EmbeddingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmbeddingApiService,
    factory: EmbeddingApiService.ɵfac,
    providedIn: 'root'
  });
  return EmbeddingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EmbeddingService = /*#__PURE__*/(() => {
  class EmbeddingService {
    constructor(api) {
      this.api = api;
    }
    createEmbedding(req) {
      return this.api.createEmbedding(req).pipe(map(resp => resp.id));
    }
    getEmbedding(req) {
      return this.api.getEmbedding(req).pipe(map(resp => resp.embedding));
    }
    updateEmbedding(req) {
      return this.api.updateEmbedding(req).pipe(map(() => true));
    }
    listEmbeddings(req) {
      return this.api.listEmbeddings(req);
    }
    deleteEmbedding(req) {
      return this.api.deleteEmbedding(req).pipe(map(() => true));
    }
  }
  EmbeddingService.ɵfac = function EmbeddingService_Factory(t) {
    return new (t || EmbeddingService)(i0.ɵɵinject(EmbeddingApiService));
  };
  EmbeddingService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: EmbeddingService,
    factory: EmbeddingService.ɵfac,
    providedIn: 'root'
  });
  return EmbeddingService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AutomatedEmbeddingsApiService = /*#__PURE__*/(() => {
  class AutomatedEmbeddingsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    refreshAccountGroupWebsiteEmbeddings(r) {
      const request = r.toApiJson ? r : new RefreshAccountGroupWebsiteEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/RefreshAccountGroupWebsiteEmbeddings", request.toApiJson(), this.apiOptions()).pipe(map(resp => RefreshAccountGroupWebsiteEmbeddingsResponse.fromProto(resp)));
    }
    getRefreshAccountGroupWebsiteEmbeddingsProgress(r) {
      const request = r.toApiJson ? r : new GetRefreshAccountGroupWebsiteEmbeddingsProgressRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/GetRefreshAccountGroupWebsiteEmbeddingsProgress", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetRefreshAccountGroupWebsiteEmbeddingsProgressResponse.fromProto(resp)));
    }
    refreshBusinessProfileEmbeddings(r) {
      const request = r.toApiJson ? r : new RefreshBusinessProfileEmbeddingsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/RefreshBusinessProfileEmbeddings", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    refreshAllBusinessProfileEmbeddings() {
      return this.http.post(this._host + "/embeddings.v1alpha1.AutomatedEmbeddingsService/RefreshAllBusinessProfileEmbeddings", {}, {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AutomatedEmbeddingsApiService.ɵfac = function AutomatedEmbeddingsApiService_Factory(t) {
    return new (t || AutomatedEmbeddingsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  AutomatedEmbeddingsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AutomatedEmbeddingsApiService,
    factory: AutomatedEmbeddingsApiService.ɵfac,
    providedIn: 'root'
  });
  return AutomatedEmbeddingsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let KnowledgeBaseApiService = /*#__PURE__*/(() => {
  class KnowledgeBaseApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createKnowledgeBase(r) {
      const request = r.toApiJson ? r : new CreateKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeBase", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateKnowledgeBaseResponse.fromProto(resp)));
    }
    getKnowledgeBase(r) {
      const request = r.toApiJson ? r : new GetKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeBase", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetKnowledgeBaseResponse.fromProto(resp)));
    }
    updateKnowledgeBase(r) {
      const request = r.toApiJson ? r : new UpdateKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeBase", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteKnowledgeBase(r) {
      const request = r.toApiJson ? r : new DeleteKnowledgeBaseRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeBase", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listKnowledgeBases(r) {
      const request = r.toApiJson ? r : new ListKnowledgeBasesRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeBases", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListKnowledgeBasesResponse.fromProto(resp)));
    }
    createKnowledgeSource(r) {
      const request = r.toApiJson ? r : new CreateKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/CreateKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateKnowledgeSourceResponse.fromProto(resp)));
    }
    getKnowledgeSource(r) {
      const request = r.toApiJson ? r : new GetKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetKnowledgeSourceResponse.fromProto(resp)));
    }
    updateKnowledgeSource(r) {
      const request = r.toApiJson ? r : new UpdateKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpdateKnowledgeSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    deleteKnowledgeSource(r) {
      const request = r.toApiJson ? r : new DeleteKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteKnowledgeSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listKnowledgeSources(r) {
      const request = r.toApiJson ? r : new ListKnowledgeSourcesRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListKnowledgeSources", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListKnowledgeSourcesResponse.fromProto(resp)));
    }
    upsertApp(r) {
      const request = r.toApiJson ? r : new UpsertAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpsertApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getApp(r) {
      const request = r.toApiJson ? r : new GetAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/GetApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAppResponse.fromProto(resp)));
    }
    deleteApp(r) {
      const request = r.toApiJson ? r : new DeleteAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/DeleteApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listApps(r) {
      const request = r.toApiJson ? r : new ListAppsRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAppsResponse.fromProto(resp)));
    }
    listAllKnowledgeSourcesForApp(r) {
      const request = r.toApiJson ? r : new ListAllKnowledgeSourcesForAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListAllKnowledgeSourcesForApp", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllKnowledgeSourcesForAppResponse.fromProto(resp)));
    }
    listAllAppsForKnowledgeSource(r) {
      const request = r.toApiJson ? r : new ListAllAppsForKnowledgeSourceRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/ListAllAppsForKnowledgeSource", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllAppsForKnowledgeSourceResponse.fromProto(resp)));
    }
    upsertKnowledgeForApp(r) {
      const request = r.toApiJson ? r : new UpsertKnowledgeForAppRequest(r);
      return this.http.post(this._host + "/embeddings.v1alpha1.KnowledgeBaseService/UpsertKnowledgeForApp", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  KnowledgeBaseApiService.ɵfac = function KnowledgeBaseApiService_Factory(t) {
    return new (t || KnowledgeBaseApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  KnowledgeBaseApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: KnowledgeBaseApiService,
    factory: KnowledgeBaseApiService.ɵfac,
    providedIn: 'root'
  });
  return KnowledgeBaseApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let KnowledgeBaseService = /*#__PURE__*/(() => {
  class KnowledgeBaseService {
    constructor(api) {
      this.api = api;
    }
    getApp(req) {
      return this.api.getApp(req).pipe(map(resp => resp.app));
    }
    updateKnowledgeBase(req) {
      return this.api.updateKnowledgeBase(req).pipe(map(() => true));
    }
    createKnowledgeSource(req) {
      return this.api.createKnowledgeSource(req).pipe(map(resp => resp));
    }
    updateKnowledgeSource(req) {
      return this.api.updateKnowledgeSource(req).pipe(map(() => true));
    }
    deleteKnowledgeSource(req) {
      return this.api.deleteKnowledgeSource(req).pipe(map(() => true));
    }
    listKnowledgeSources(req) {
      return this.api.listKnowledgeSources(req).pipe(map(resp => resp));
    }
    listAllKnowledgeSourcesForApp(req) {
      return this.api.listAllKnowledgeSourcesForApp(req);
    }
    listAllAppsForKnowledgeSource(req) {
      return this.api.listAllAppsForKnowledgeSource(req);
    }
    upsertKnowledgeForApp(req) {
      return this.api.upsertKnowledgeForApp(req).pipe(map(() => true));
    }
  }
  KnowledgeBaseService.ɵfac = function KnowledgeBaseService_Factory(t) {
    return new (t || KnowledgeBaseService)(i0.ɵɵinject(KnowledgeBaseApiService));
  };
  KnowledgeBaseService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: KnowledgeBaseService,
    factory: KnowledgeBaseService.ɵfac,
    providedIn: 'root'
  });
  return KnowledgeBaseService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { App, CreateEmbeddingResponse, CreateKnowledgeSourceResponse, Embedding, EmbeddingCitation, EmbeddingMetadata, EmbeddingRelationship, EmbeddingRelationshipAccountGroup, EmbeddingService, EmbeddingSourceType, EmbeddingVendorModel, GetAppResponse, GetEmbeddingResponse, KnowledgeBaseService, KnowledgeSource, KnowledgeSourceConfigType, ListAllAppsForKnowledgeSourceResponse, ListAllKnowledgeSourcesForAppResponse, ListEmbeddingsResponse, ListKnowledgeSourcesResponse, PagedResponseMetadata };
